<script>
    import { format } from 'date-fns';
    import user from '../state/user';

    export let resId;
    export let code;

    let submitting = false;

    let message = {
        contents: '',
        isError: false
    };

    let showForm = null;
    let reservation = null;

    function onLoad() {
        user.getReservation(resId, code).then((res) => {
            reservation = res;

            showForm = !!res;
        });
    }

    async function onSubmit() {
        submitting = true;
        await user.cancelReservation(resId, code);
        submitting = false;

        message.contents = 'Rezervace byla zrušena!';
        message.isError = false;
        showForm = false;
    }

    function formatDate(date) {
        return format(date, 'D. M. YYYY');
    }

    function formatTime(date) {
        return format(date, 'H:mm');
    }

    // Check reservation and code
    onLoad();
</script>

<style>
    .controls {
        position: absolute;
        bottom: 20px;
        z-index: 1;
    }

    .group {
        display: inline-flex;
        border-radius: 20px;
        overflow: hidden;
        margin: 0 10px 10px 0;
    }

    .group .caption, .group .text {
        padding: 2px 8px;
    }

    .group .caption {
        font-weight: 500;
        background: #e4e4e4;
    }

    .group .text {
        background: #ececec;
        /* flex: 1; */
    }

    .modal-card-foot { padding: 38px 20px; }
</style>

<div class="modal is-active">
    <div class="modal-background"></div>
    <div class="modal-card">
        <header class="modal-card-head">
            <div class="modal-card-title">
                Zrušení rezervace
            </div>
        </header>
        <section class="modal-card-body">
            {#if showForm === true}
                {#if message.isError}
                    <div class="notification is-danger">
                        {message.contents}
                    </div>
                {/if}

                <form on:submit|preventDefault={onSubmit}>
                    <div>
                        <div class="group">
                            <span class="caption">Lekce</span>
                            <span class="text">{reservation.evn_title}</span>
                        </div>

                        <div class="group">
                            <span class="caption">Datum lekce</span>
                            <span class="text">{formatDate(reservation.evr_from)}</span>
                        </div>
                    </div>

                    <div>
                        <div class="group">
                            <span class="caption">Začátek lekce</span>
                            <span class="text">{formatTime(reservation.evr_from)}</span>
                        </div>
                        <div class="group">
                            <span class="caption">Konec lekce</span>
                            <span class="text">{formatTime(reservation.evr_to)}</span>
                        </div>
                    </div>

                    <div class="controls">
                        <button class="button"
                                class:is-loading={submitting}
                                disabled={reservation.res_canceled > 0}>
                            Zrušit rezervaci
                        </button>
                    </div>
                </form>

                {#if reservation.res_canceled > 0}
                    <div class="notification is-danger">
                        Tato rezervace již byla zrušena.
                    </div>
                {/if}
            {:else if showForm === null}
                Načítání ...
            {:else if message.contents && message.contents.length}
                <div class="notification is-success">
                    {message.contents}
                </div>

                <div class="controls">
                    <a class="button" href="/">Přejít do rezervačního systému</a>
                </div>
            {:else}
                <div class="notification is-danger">
                    Při načítání došlo k chybě, zkontrolujte odkaz!
                </div>
            {/if}
        </section>

        <footer class="modal-card-foot"></footer>
    </div>
</div>